import type { Route } from "./+types/home";
import HeroSection, { links as heroStyles } from "~/components/pages/home/hero-section";
import WhySection from "~/components/pages/home/why-section";
import AboutSection from "~/components/pages/home/about-section";
import FooterSection from "~/layout/public/footer-section";
import type { LoaderFunctionArgs } from "react-router";
import { getLocalData } from "~/data/lib/serverStore.server";
import { getPopCourses } from "~/data/courses.server";
import PopularCoursesSection from "~/components/pages/home/popular-courses-section";
import LatestBlogsSection from "~/components/pages/home/latest-blogs-section";
import { getFeaturedBlogs } from "~/data/blog.server";
import { FEATURED_BLOG_SLUGS } from "~/config/featuredBlogPosts";

export async function loader(_: LoaderFunctionArgs) {
  const data = await getLocalData();
  const popCourses = await getPopCourses();
  const courses = popCourses.props.data?.data;
  const featuredBlogs = await getFeaturedBlogs(FEATURED_BLOG_SLUGS);
  const blogPosts = featuredBlogs.props.data;
  return { ...data, courses, blogPosts };
}

export default function Home() {
  return (
    <>
      <HeroSection />
      <main id="main">
        <AboutSection />
        <WhySection />
        {/* upcomming section here */}
        {/* {courses && courses.length > 0 ? */}
        <PopularCoursesSection />
        {/* : null
        } */}
        <LatestBlogsSection />
        <FooterSection />
      </main>
    </>
  );
}

export function links() {
  return [...heroStyles()];
}
